import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Container, Row, Col, Input, Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import ReactGA4 from 'react-ga4';

import config from '../../../../config';

import { getProduct, getProductMatchingPack } from '../../ProductActions';
import { setCartItem, getCartItemByProduct, getCartItemFromProduct, formatAnalyticsItems } from '../../../Cart/CartActions';
import { getContentBlockItemByName, getContentBlockMixedItem } from '../../../Cms/CmsActions';
import { getLanguagePath } from '../../../Intl/IntlActions';

import Breadcrumbs from '../../../App/components/view/Breadcrumbs';
import FileLoader from '../../../../components/Content/FileLoader';
import HtmlComponent from '../../../../components/Text/HtmlComponent';
import Price from '../../../Currency/components/view/Price';
import CartItemQuantitySelector from '../../../Cart/components/form/CartItemQuantitySelector';
import CmsBlockItem from '../../../Cms/components/content/CmsBlockItem';
import CmsPanel from '../../../Cms/components/content/CmsPanel';
import ReviewSummary from '../../../Review/components/view/ReviewSummary';
import PreFooter from '../../../App/components/PreFooter';


class ProductViewPage extends Component {
    // getSeo = () => {
    //     return {
    //         title: getTranslation(this.props.product, 'name', this.props.intl.locale),
    //         meta: [
    //             {
    //                 name: 'description',
    //                 content: getTranslation(this.props.product, 'description', this.props.intl.locale),
    //             },
    //         ],
    //         link: enabledLanguages.filter(lang => lang !== this.props.intl.locale).map(lang => ({
    //             rel: 'alternate',
    //             href: getProductSlugPath(this.props.product, lang),
    //             hrefLang: lang,
    //         })),
    //     };
    // }

    handleSelectPack = pack => {
        const item = getCartItemFromProduct(this.props.product, pack.quantity, pack, this.props.intl.locale);
        this.props.dispatch(setCartItem(item));
        return item;
    }

    handleAddToCart = () => {
        let item = this.props.cartItem;
        if(!this.props.cartItem || !this.props.cartItem.quantity) {
            item = this.handleSelectPack({ quantity: 1 });
        }
        this.handleTrackAnalytics(item);
        this.props.history.push(getLanguagePath('/cart/preview', this.props.intl.locale));
    }

    handleTrackAnalytics = item => {
        if(typeof window !== 'undefined' && config.google.analytics.trackingCodeGA4) {
                // console.log('Analytics::: Track add_to_cart', quantity, diff);

                // GA: New
                ReactGA4.event('add_to_cart', {
                    currency: this.props.currency,
                    value: this.props.product.priceHT,
                    items: formatAnalyticsItems([item]),
                });
            }
        if(typeof window !== 'undefined' && window.fbq) {
            window.fbq('track', 'AddToCart', {
                content_name: this.props.product.name,
                content_ids: [this.props.product.sku || this.props.product._id],
                content_type: 'product',
                value: this.props.product.priceHT,
                currency: this.props.currency,
            });
        }
    }

    render() {
        const { product, page, cartItem, intl } = this.props;
        const matchingPack = getProductMatchingPack(product, cartItem ? cartItem.quantity : 1);
        // <Helmet {...this.getSeo()} />
        const title = (getContentBlockItemByName(page.blocks, 'title') || {}).text || '';
        const description = (getContentBlockItemByName(page.blocks, 'description') || {}).text || '';
        const image = getContentBlockItemByName(page.blocks, 'image');
        const shippingInfo = getContentBlockItemByName(page.blocks, 'shipping-info');
        const voucherInfo = getContentBlockItemByName(page.blocks, 'voucher-info');
        const spoonInfo = getContentBlockItemByName(page.blocks, 'spoon-info');
        const subText = getContentBlockItemByName(page.blocks, 'subtext');
        const cta = getContentBlockItemByName(page.blocks, 'call-to-action');

        return (
            <Fragment>
                <Container fluid className="bg-warning">
                    <Container>
                        <Breadcrumbs crumb={page && page.title} />
                        <Row>
                            <Col xs="12" md="6" className="bg-custom-plant">
                                {image && image.path && (
                                    <div className="position-relative pt-0 pt-md-5" style={{ minHeight: '400px' }}>
                                        <div className="position-absolute w-100 text-center">
                                            <FileLoader filename={image.path} loadonmount hidePlaceholders alt={image.text} />
                                        </div>
                                    </div>
                                )}
                            </Col>
                            <Col>
                                <div className="px-2 px-md-0 pt-3">
                                    <span className="d-block text-lg text-white">{config.application.name}<sup>&reg;</sup></span>
                                    {title && <h1 className="text-dark font-weight-bold">{title}</h1>}
                                    {description && <div className="text-dark"><HtmlComponent text={description} /></div>}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
                {
                    product && (
                        <Container className="pb-5">
                            <Row>
                                <Col xs="12" md="6">
                                    <div className="pt-0 pt-md-5">
                                        <div className="mt-3 mt-md-5">
                                            <div className="pl-2 border-left-warning text-lg">
                                                <CmsBlockItem item={voucherInfo} type="html" />
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        spoonInfo && (
                                            <Fragment>
                                                <div className="d-none d-md-block mt-3 mt-md-5 position-relative">
                                                    {getContentBlockMixedItem(spoonInfo, 'image') && <CmsBlockItem item={getContentBlockMixedItem(spoonInfo, 'image')} type="image" />}
                                                    {getContentBlockMixedItem(spoonInfo, 'image-text') && (
                                                        <div className="d-none d-md-block position-absolute mr-3 p-2 p-lg-4 w-50 bg-secondary text-lg text-white special-font" style={{ bottom: '-30px', right: '-30px' }}>
                                                            <CmsBlockItem item={getContentBlockMixedItem(spoonInfo, 'image-text')} type="text" />
                                                        </div>
                                                    )}
                                                </div>
                                                <CmsBlockItem item={spoonInfo} type="html" />
                                            </Fragment>
                                        )
                                    }
                                </Col>
                                <Col>
                                    <div className="mx-0 p-4 override-block-lg bg-white">
                                        <CartItemQuantitySelector product={product} disableQuantityEdition onAddToCart={this.handleAddToCart} />

                                        {
                                            product.packs && product.packs.length
                                                ? (
                                                    <Fragment>
                                                        <div className="text-primary"><h5 className="d-inline-block"><FormattedMessage id="productPackChoiceTitle" defaultMessage="Discover our packs" /></h5> <span><FormattedMessage id="priceHT" defaultMessage="Price excl. tax" /></span></div>
                                                        <Row>
                                                            {product.packs.sort((packA, packB) => packA.quantity - packB.quantity).map((pack, index) => (
                                                                <Col key={pack.label || index} xs="6" lg="4">
                                                                    <div
                                                                        onClick={() => this.handleSelectPack(pack)}
                                                                        className={classnames('position-relative', !pack.isMonthlyConsumption && 'my-2', 'p-2', pack.isMonthlyConsumption && 'pt-4', 'rounded', 'border', matchingPack && matchingPack.quantity === pack.quantity && ['border-warning', 'border-2'])}
                                                                    >
                                                                        {pack.isMonthlyConsumption && (
                                                                            <span className={classnames('d-block', 'position-absolute', 'py-1', 'text-center', 'text-xs', 'w-100', matchingPack && matchingPack.quantity === pack.quantity ? ['bg-warning', 'text-white'] : 'bg-light')} style={{ top: '-5px', left: 0, borderRadius: '5px 5px 0 0', fontSize: '0.6rem' }}><FormattedMessage id="productPackMonthlyConsumptionLabel" defaultMessage="Recommended for 1 month" /></span>
                                                                        )}
                                                                        <div>
                                                                            <FormattedMessage id="productUnitCountLabel" defaultMessage="{count} bottle(s)" values={{ count: pack.quantity }} />
                                                                            {' '}{false && pack.freeCount > 0 && <FormattedMessage id="productPackFreeCount" defaultMessage="+{count} free" values={{ count: pack.freeCount }} />}
                                                                        </div>
                                                                        <div className="d-flex justify-content-between pt-1">
                                                                            {product.priceHT !== pack.unitPriceHT ? <span className="d-block text-crossed"><Price amount={product.priceHT * pack.quantity} /></span> : <span>{' '}</span>}
                                                                            <span className="d-block h5 m-0 text-dark font-weight-bold"><Price amount={pack.unitPriceHT * pack.quantity} /></span>
                                                                        </div>
                                                                        {!pack.freeCount && product.priceHT !== pack.unitPriceHT && <small className="text-dark"><FormattedMessage id="productPackUnitPrice" defaultMessage="Or {price}/bottle" values={{ price: <Price amount={pack.unitPriceHT} /> }} /></small>}
                                                                        {pack.freeCount > 0 && <small className="text-warning font-weight-bold"><FormattedMessage id="productPackFreeCount" defaultMessage="+{count} FREE bottle(s)" values={{ count: pack.freeCount }} /></small>}
                                                                    </div>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                    </Fragment>
                                            ) : null
                                        }

                                        <div className="my-3">
                                            <CmsBlockItem item={shippingInfo} type="html" />
                                        </div>

                                        {/* <div className="border border-left-0 border-right-0 my-3 py-3 text-lg text-primary" style={{ fontSize: '1.5rem' }}>
                                            <span className="d-inline-block"><FormattedMessage id="productSpoonLabel" defaultMessage="The measuring spoon" /></span> <span className="text-dark"><FormattedMessage id="productSpoonOffer" defaultMessage="as a gift" /></span>
                                        </div> */}


                                        <div className="my-3">
                                            <CmsBlockItem item={subText} type="html" />
                                        </div>

                                        {cta && cta.path && (
                                            <div className="text-right">
                                                <Button color="warning" size="lg" tag={Link} to={cta.path}>{cta.text}</Button>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    )
                }


                <CmsPanel slug="product-benefits" />

                <ReviewSummary locale={this.props.intl.locale} />

                <PreFooter />
            </Fragment>
        );
    }
}

function mapStateToProps(store, props) {
    const productBlockItem = getContentBlockItemByName(props.page.blocks, 'product');
    const product = productBlockItem ? getProduct(store, productBlockItem.text) : null;
    return {
        currency: store.currency.currency,
        product,
        cartItem: product ? getCartItemByProduct(store, product) : null,
    };
}

ProductViewPage.defaultProps = {
    product: null,
    cartItem: null,
};

ProductViewPage.propTypes = {
    page: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    currency: PropTypes.string.isRequired,
    product: PropTypes.object,
    cartItem: PropTypes.object,
};

export default connect(mapStateToProps)(withRouter(injectIntl(ProductViewPage)));


export const ProductViewPageModel = {
    type: 'page',
    name: 'product',
    blocks: [
        {
            name: 'product', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'text', // || text || link || image || mixed (with children)
        },
        {
            name: 'title', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'text', // || text || link || image || mixed (with children)
        },
        {
            name: 'description',
            max: 1,
            type: 'html',
        },
        {
            name: 'image',
            max: 1,
            type: 'image',
        },
        {
            name: 'shipping-info',
            max: 1,
            type: 'html',
        },
        {
            name: 'voucher-info',
            max: 1,
            type: 'html',
        },
        {
            name: 'spoon-info',
            max: 1,
            type: 'mixed',
            blocks: [
                {
                    name: 'image-text',
                    type: 'text',
                },
                {
                    name: 'image',
                    type: 'image',
                },
            ],
        },
        {
            name: 'subtext',
            max: 1,
            type: 'html',
        },
        {
            name: 'call-to-action',
            type: 'link',
            max: 1,
        },
    ],
};
